import { HeadCell } from 'components/ui/EnhancedTable';
import useAxios from 'library/axios'; 
import { useState } from 'react';
import {IProblem,  IProblemSearch } from "../models/Problem";
import { useTranslation  } from 'react-i18next';
import { IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { useNavigate } from 'react-router-dom';


const _ = () => {

    const axios = useAxios();     

    const createProblem = async (problem: IProblem)  =>       
        await (await axios.post('/api/production/problem/create', problem)).data;       
        
    const updateProblem = async (problem: IProblem)  =>       
        await (await axios.post('/api/production/problem/update', problem)).data; 
    
    const getProblem = async (id  : number )  => {
      const {data} = (await axios.get(`/api/production/problem/get-problem/${id}`));
      return await data;
    }

    const getProblems = async (criteria: IProblemSearch, pagination?: IPagination) : Promise<IProblem[]> => {
      const pageSize = pagination?.pageSize ?? 50;
      const pageNumber = pagination?.pageNumber ?? 1;

      const {title, description, } = criteria;

      const {data} = (await axios.get(`/api/production/problem/get-problems?description=${description}&title=${title}&pageSize=${pageSize}&pageNumber=${pageNumber}`));
      return await data;
    }
      
    return {    
      createProblem,
      updateProblem,

      getProblem,
      getProblems 
    } 
}

export default _;


export const useBasicFilterProblem = ( onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IProblem) => void  ) => {

  const { getProblems } = _();

  const { t, i18n } = useTranslation();   
  const navigate = useNavigate();

  

  const [headProblemCells, setHeadProblemCells]  = useState<HeadCell<IProblem>[]>([
    {id:'title', label : t('Title'),  display: true, type: 'string', },
    {id:'description', label : t('Description'),  display: true, type: 'string', },
    {id:'issueDate', label : t('Date'),  display: true, type: 'date', },  
  ]); 

  const [filterElements, ] = useState([       
        {name: 'title', text: t('Title'), value: ''}, 
        {name: 'description', text: t('Description'), value: ''},                 
      ]);

  const [filteredProblems, ] = useState<IProblem[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination): Promise<IProblem[]> => {
            
    const title = filterElements.find( elt => elt.name === 'title')?.value || '';
    const description = filterElements.find( elt => elt.name === 'description')?.value || '';
    

    const arr = await getProblems( {title, description}, pagination );
    
    return arr;
  }

  const objKey: keyof IProblem = 'id';

  return {
    title: t('Problem'), headCells: headProblemCells, objKey,
    filterElements, rows: filteredProblems, 
    onFilterButtonClick, onRowDoubleClick
  }
}

